import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from '../_services/api/axios';
import withErrorHandler from '../_hoc/withErrorHandler';
import * as actionCreators from '../_store/actions/index';
import { getTranslate } from 'react-localize-redux';
import {toastr} from 'react-redux-toastr'

import { 
  Loading
} from 'components'
class Defaults extends Component {
  state = {
    confirmMessage : {
        message : null
    }
  }
  componentDidMount() {
    this.props.onInit();
    this.onInit();    
  }
  componentDidUpdate = (prevProps, prevState, snapshot) => {
    //relogin
    if(!Object.is(this.props.auth, prevProps.auth)) {
      this.setState(prevState => ({
        confirmMessage: {
          message: null
        }
      }));
      this.onInit();          
    }
    if(!Object.is(this.props.visualMessage, prevProps.visualMessage)) {
      let showVisualMessage = true;
      if(this.props.visualMessage.obj.response && this.props.visualMessage.obj.response.hideVisualError) {
        showVisualMessage = false;
      }
      if(showVisualMessage) {
        if(this.props.visualMessage.type === 'success') {
          let title = "Success";
          let message = this.props.visualMessage.message;
          if(this.props.translate('global.success.general.title') !== '-') title = this.props.translate('global.success.general.title');
          if(this.props.translate('global.success.general.'+this.props.visualMessage.scope+'.'+this.props.visualMessage.key.toLowerCase()) !== '-') message = this.props.translate('global.success.general.'+this.props.visualMessage.scope+'.'+this.props.visualMessage.key.toLowerCase());
          toastr.success(title,message);
        }
        else if (this.props.visualMessage.type === 'error') {
          let title = "Error";
          let message = this.props.visualMessage.message;
          if(this.props.translate('global.error.general.title') !== '-') title = this.props.translate('global.error.general.title');
          if(this.props.translate('global.error.general.'+this.props.visualMessage.scope+'.'+this.props.visualMessage.key.toLowerCase()) !== '-') message = this.props.translate('global.error.general.'+this.props.visualMessage.scope+'.'+this.props.visualMessage.key.toLowerCase());
          toastr.error(title,message);
        }
      }
      //this.props.onVisualMessageReset();
    }
  }
  onInit = () => {
    if(this.props.auth.isAuthenticated) {
      this.props.onInitCompany();
    }
  }
  render() {
    if(this.props.state.running_requests > 0 && this.props.state.show_globalSpinner) {
      return <Loading/>;
    }
    return null;
  }
}

const mapStateToProps = state => {
    return {
        defaults: state.defaults,
        state: state.fetching,
        auth: state.auth,
        visualMessage: state.visualMessage,
        translate: getTranslate(state.locale)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onInit: () => dispatch(actionCreators.defaultsFetch()),
        onInitCompany: () => dispatch(actionCreators.settingsCompanyFetch()),
        onVisualMessageReset: () => dispatch(actionCreators.visualMessageReset())
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(Defaults, axios));


// WEBPACK FOOTER //
// ./src/_helpers/Defaults.js